angular.module('leanlaw').directive('llLoaderNext', [function () {
  return {
    restrict: 'A',
    template: require("./views/ll-loader-next.html"),
    scope: {
      what: '@'
    }
  };
}]);